export const AccountingReviewReportConstants = {
    DEFAULT_FILENAME: 'AccountingReviewReport.xlsx',
} as const;
